import React, { FC } from "react";
import makeStyles from "@material-ui/core/styles/makeStyles";
import Button from "../../../components/Button";
import { AdapterLink } from "../../../components/Adopter";
import { Routes } from "../../../constants/routes";
import { IServiceByProvider } from "../types";

const useStyles = makeStyles(() => ({
  categoryCardContainer: {
    height: "100%",
    borderRadius: 16,
    boxShadow: "0 0 4px 0 #c2c9d6",
    padding: 30,
    backgroundColor: "#fff",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexWrap: "nowrap",
  },
  iconNameContainer: {
    display: "flex",
    alignItems: "center",
  },
  textContainer: {
    display: "flex",
    flexDirection: "column",
  },
  name: {
    fontWeight: 500,
    lineHeight: 1.33,
    color: "#231f20",
    fontSize: "1.25rem",
  },
  country: {
    lineHeight: 1,
    fontSize: "1rem",
  },
  iconContainer: {
    borderRadius: 10,
    backgroundColor: "#eeeeed",
    padding: "0.625rem",
    marginRight: "1.875rem",
  },
  icon: {
    verticalAlign: "middle",
    borderStyle: "none",
  },
  button: {
    minWidth: 220,
  },
}));

export const CategoryServiceCard: FC<IServiceByProvider> = ({
  id,
  countries,
  providerImagePath,
  providerName,
}) => {
  const classes = useStyles();

  const onViewCategory = () => {
    // Logic to handle viewing the category
    // https://dev.worlded.us/services/lawyer-consultation
  };

  return (
    <div className={classes.categoryCardContainer}>
      <div className={classes.iconNameContainer}>
        <div className={classes.iconContainer}>
          <img
            alt="logo"
            className={classes.icon}
            src={providerImagePath}
            width={50}
          />
        </div>
        <div className={classes.textContainer}>
          <div className={classes.name}>{providerName}</div>
          <div className={classes.country}>{countries}</div>
        </div>
      </div>
      <AdapterLink to={`/0/${Routes.SERVICE_LIST}/${id}`}>
        <Button
          variant={"contained"}
          color={"secondary"}
          className={classes.button}
          onClick={onViewCategory}
        >
          View More
        </Button>
      </AdapterLink>
    </div>
  );
};
